import store from '@/stores/store'
import { ModuleContext } from '@/stores/moduleConst'
import LocalForage from 'localforage'

// Implement the driver here.
class IndexedDB {
  _db = null;
  _dbName = 'emis_enrollment_portal';
  _keyField = '_k';
  _valueField = '_v';
  _table = 'cache';

  constructor () {
    const me = this
    const { Context } = store.state[ModuleContext]
    if (Context) {
      me._table = String(Context.TenantID)
      try {
        this._db = LocalForage
        this._db.config({
          driver: LocalForage.INDEXEDDB,
          name: `${me._dbName}_${me._table}`,
          version: 1.0,
          storeName: 'keyvaluepairs', // Should be alphanumeric, with underscores.
          description: 'Index db for emis enrollment online',
        })
      } catch (err) {
        //   console.error(err);
      }
    }
  }

  /**
   * Lấy thông tin dữ liệu lưu trong index theo key
   * @param {*} key
   * @param {*} fn
   * @returns
   * HTHIEP 29.04.2022
   */
  async get (key, fn) {
    key = `ms_emis_enrollment_portal_${key}`
    let data = await this._db.getItem(key, fn)
    try {
      data = JSON.parse(data)
    } catch (error) {
      //
    }
    return data
  }

  /**
   * Lưu trữ dữ liệu vào indexdb
   * @param {*} key
   * @param {*} data
   * @param {*} fn
   * HTHIEP 29.04.2022
   */
  async set (key, data, fn) {
    key = `ms_emis_enrollment_portal_${key}`
    let stringData = ''
    if (typeof data === 'object') {
      stringData = JSON.stringify(data)
    } else {
      stringData = data
    }
    await this._db.setItem(key, stringData, fn)
  }

  /**
   * Xóa dữ liệu trong indexdb theo key
   * @param {*} key
   * @param {*} fn
   * HTHIEP 29.04.2022
   */
  async delete (key, fn) {
    key = `ms_emis_enrollment_portal_${key}`
    await this._db.removeItem(key, fn)
  }

  /**
   * Clear toàn bộ dữ liệu trong indexdb
   * HTHIEP 29.04.2022
   */
  async clear () {
    await this._db.clear()
  }

  getTable () {
    return this._table
  }
}

export default IndexedDB
